import React from 'react';
import { Field } from 'formik';
import { Row, Col, Label, FormGroup, Button, Input, FormFeedback } from 'reactstrap';
import * as dataSeed from '../../shared/DataSeed';

class Page6Summary extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
 const { errors, touched, values, state, props, occupations, onAgree, reloadCaptcha, setFieldValue } = this.props;


 return (
    <React.Fragment>
        <FormGroup tag="fieldset">
            <legend>Ringkasan Data</legend>
        </FormGroup>
        <table className="table table-striped table-sm">
            <tbody>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Depan</td>
                    <td className="col-3">: {values.FirstName}</td>
                    <td className="font-weight-bold col-3">Nama Tengah</td>
                    <td className="col-3">: {values.MiddleName}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Belakang</td>
                    <td className="col-3">: {values.LastName}</td>
                    <td className="font-weight-bold col-3">Warga Negara</td>
                    <td className="col-3">: {values.Nationality !== '' && dataSeed.countries.find(el => el.id.toString() === values.Nationality).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nomor KTP</td>
                    <td className="col-3">: {values.KTPNumber}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Tempat Lahir</td>
                    <td className="col-3">: {values.BirthPlace}</td>
                    <td className="font-weight-bold col-3">Tgl. Lahir</td>
                    <td className="col-3">: {values.BirthDate}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Jenis Kelamin</td>
                    <td className="col-3">: {values.GenderId !== '' && dataSeed.genders.find(el => el.id.toString() === values.GenderId).name}</td>
                    <td className="font-weight-bold col-3">Agama</td>
                    <td className="col-3">: {values.Religion !== '' && dataSeed.religions.find(el => el.id.toString() === values.Religion).name}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">NPWP</td>
                    <td className="col-3">: {values.NPWP !== '' && dataSeed.nPWPs.find(el => el.id.toString() === values.NPWP).name}</td>
                    <td className="font-weight-bold col-3">No. NPWP</td>
                    <td className="col-3">: {values.NPWPNumber}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Status Pernikahan</td>
                    <td className="col-3">: {values.MaritalStatusId !== '' && dataSeed.maritalStatuses.find(el => el.id.toString() === values.MaritalStatusId).name}</td>
                    <td className="font-weight-bold col-3">Nama Pasangan</td>
                    <td className="col-3">: { values.MaritalStatusId == '2' ? values.SpouseName : ''}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Pendidikan</td>
                    <td className="col-3">:  {values.EducationId !== '' && dataSeed.educations.find(el => el.id.toString() === values.EducationId).name}</td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3">: </td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3" >Alamat</td>
                    <td className="col-3" colSpan="3">: {values.ResidentialAddressLine1}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3" ></td>
                    <td className="col-3" colSpan="3">: {values.ResidentialAddressLine2}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Negara</td>
                    <td className="col-3">: {values.Country}</td>
                    <td className="font-weight-bold col-3">Provinsi</td>
                    <td className="col-3">: {props.provinces.map((item, key) => { if (item.Id == values.ResidentialAddressprovinceId) { return item.Name; }})} </td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kota</td>
                    <td className="col-3">: {values.ResidentialAddressCityId}</td>
                   
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">RT/RW</td>
                    <td className="col-3">: {values.RT}/{values.RW}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Kode Pos</td>
                    <td className="col-3">: {values.ResidentialAddressPostalCode}</td>
                    <td className="font-weight-bold col-3">Telp Rumah</td>
                    <td className="col-3">: {values.HomePhone}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">No HP</td>
                    <td className="col-3">: {values.MobilePhone}</td>
                    <td className="font-weight-bold col-3">Email</td>
                    <td className="col-3">: {values.Email}</td>
                </tr>
              
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Pekerjaan</td>
                    <td className="col-3">: {values.OccupationId !== '' && dataSeed.occupationBOs.find(el => el.id.toString() === values.OccupationId).name}
                    </td>
                    <td className="font-weight-bold col-3">Pekerjaan Lainnya</td>
                    <td className="col-3">: {values.OccupationOthers}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Posisi</td>
                    <td className="col-3">: {values.PositionText}</td>
                    
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Bidang Usaha</td>
                    <td className="col-3">: {values.BusinessFieldText}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-3">: {values.CompanyName}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Alamat Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-9">: {values.CompanyAddress}</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">No Telepon Tempat Bekerja/Usaha/Sekolah</td>
                    <td className="col-3">: {values.CompanyPhoneAreaCode} - {values.CompanyPhoneNumber}</td>
                    <td className="font-weight-bold col-3">Lama Bekerja / Usaha</td>
                    <td className="col-3">: {values.LengthOfWork} Tahun</td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                    <td className="font-weight-bold col-3"></td>
                    <td className="col-3"></td>
                </tr>
                <tr className="d-flex">
                    <td className="font-weight-bold col-3">Nama Ahli Waris</td>
                    <td className="col-3">: {values.HeirName}</td>
                    <td className="font-weight-bold col-3">Hubungan Ahli Waris</td>
                    <td className="col-3">: {values.HeirRelation}</td>
                </tr>
            
            </tbody>
        </table>
        <Row>
            <Col md="12">
            <FormGroup check>
                            <Label check>
                                <Input type="checkbox" name="AgreementPernyataan1" id="AgreementPernyataan1" onClick={(e) => onAgree(e, setFieldValue)}
                                 checked={values.AgreementPernyataan1}
                                invalid={errors.AgreementPernyataan1 && touched.AgreementPernyataan1} 
                                />
                                <b>Nasabah dengan ini menyatakan dan menjamin bahwa informasi yang diisi sehubungan dengan Pengkinian Data  adalah benar dan dalam kondisi yang sebenarnya 
                                    dan dapat dipertanggungjawabkan secara hukum.<span className="text-danger">*</span></b>
                                {errors.AgreementPernyataan1 && touched.AgreementPernyataan1 ? (
                            <FormFeedback>{errors.AgreementPernyataan1}</FormFeedback>
                        ) : null}
                            </Label>
                            
                        </FormGroup>
            </Col>
        </Row>
        <br />
        <Row>
            <Col md="12">
            <FormGroup check>
                            <Label check>
                                <Input type="checkbox" name="AgreementPernyataan2" id="AgreementPernyataan2" onClick={(e) => onAgree(e, setFieldValue)}
                                 checked={values.AgreementPernyataan2}
                                invalid={errors.AgreementPernyataan2 && touched.AgreementPernyataan2} 
                                />
                                <b>Nasabah dengan ini membebaskan Perusahaan dari tuntuan hukum dan kerugian yang mungkin timbul atas tindakan yang dilakukan Perusahaan apabila terdapat data, 
                                    informasi dan dokumen pendukung yang telah berubah yang tidak dilaporkan Nasabah kepada Perusahaan.<span className="text-danger">*</span></b>
                                {errors.AgreementPernyataan2 && touched.AgreementPernyataan2 ? (
                            <FormFeedback>{errors.AgreementPernyataan2}</FormFeedback>
                        ) : null}
                            </Label>
                            
                        </FormGroup>
            </Col>
        </Row>
        <br />
        {/* <Row>
            <Col md="2" sm="5" xs="12">
                <FormGroup>
                    <Label>Kode Keamanan<span className="text-danger">*</span></Label><br />
                    <img src={state.imageValidation + '?' + state.imageHash} alt="" />
                    <Button onClick={() => reloadCaptcha()} type="button" outline color="info" size="sm">Reload Captcha</Button>
                    <Input tag={Field} name="ValidationCode" value={state.validationCode}  required="required" maxLength="4" bsSize="sm" />
                </FormGroup>
            </Col>
            <Col md="5">
            </Col>
        </Row> */}
        <Row>
            <Col md="12">
                &nbsp;
            </Col>
        </Row>
    </React.Fragment>
 )}
                                }

                                export default Page6Summary;


// WEBPACK FOOTER //
// ./src/components/PengkinianData/Page6Summary.js